import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { MarshallingTypeExclusionProvider } from "presentation/store/MarshallingTypeExclusion/MarshallingTypeExclusionProvider";
import { MarshallingTypeExclusionMaintenance } from "presentation/view/section/MarshallingTypeExclusion/MarshallingTypeExclusionMaintenance";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const MarshallingTypeExclusionCriteriaContMain = () => {
    return <ANAInfoWrapper permission={Permission.MARSHALLING_TYPE_EXCL_CRITERIA_MAINTENANCE}>
        <MessageBarWrapper>
            <MarshallingTypeExclusionProvider>
                <GridStyles/>
                <MarshallingTypeExclusionMaintenance/>
            </MarshallingTypeExclusionProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default MarshallingTypeExclusionCriteriaContMain;